/* eslint-disable react/prop-types */
/* eslint-disable react/no-unstable-nested-components */
import React from 'react';
import { useSelector } from 'react-redux';
import { ChannelList } from 'stream-chat-react';
import { ChannelSearch } from '../ChannelSearch/ChannelSearch';
import { TeamChannelList } from '../TeamChannelList/TeamChannelList.tsx';
import { ChannelPreview } from '../ChannelPreview/ChannelPreview.tsx';
import { KeyboardDoubleArrowLeft,
  KeyboardDoubleArrowRight,
   QuestionAnswer } from '@mui/icons-material';
import { Button,
  useMediaQuery } from '@mui/material';
import theme from '../../../utils/theme';
import { Typography,
  Box } from '@mui/material';

const options = {
  state: true,
  watch: true,
  presence: true,
  // limit: 7,
};
const sort = {
  last_message_at: -1,
  updated_at: -1,
};

const customChannelTeamFilter = (channels) => channels.filter((channel) => (channel.type === 'team' || channel.type === 'messaging'));

const TeamChannelsList = ({ streamUser, fullScreen }) => (
  <ChannelList
    channelRenderFilterFn={customChannelTeamFilter}
    filters={{
      members: { $in: [streamUser.auth0UserId.replace('|', '').replace('.', '')] },
    }}
    options={options}
    sort={sort}
    List={(listProps) => (
      <TeamChannelList
        {...listProps}
        fullScreen={fullScreen}
      />
    )}
    Preview={(previewProps) => (
      <ChannelPreview
        {...previewProps}
        fullScreen={fullScreen}
      />
    )}
  />
);

export const Sidebar = ({ popout = false }) => {
  const [expanded, setExpanded] = React.useState(false);
  const fullScreen = popout || useMediaQuery(theme.breakpoints.down('md'));
  const selectedBarn = useSelector((state) => state.barn.selectedBarn)
  const streamUser = useSelector((state) => state.stream.streamUser)
  return (
  <Box className="sidebar" sx={{ width: (fullScreen && !expanded) ? 60 : 'inherit'}}>
    <div className="channel-list-bar">
      {
        !popout && (
          <Box sx={{ display: 'flex', alignItems: 'center', p: 2 }}>
            <QuestionAnswer sx={{ color: '#ffffff', fontSize: 30, mr: 2 }} />
            {!fullScreen && (
              <Typography sx={{ color: '#ffffff', fontSize: 30, fontWeight: 600  }}>Questri Chat</Typography>
            )}
          </Box>
        )
      }
      {
        popout && (
          <Box sx={{ backgroundColor: 'rgb(244, 244, 244)'}}>
            {
              <Button
                size="small"
                sx={{ fontSize: 10 }}
                onClick={() => { setExpanded(!expanded)}}
                startIcon={expanded && <KeyboardDoubleArrowLeft />}
                endIcon={!expanded && <KeyboardDoubleArrowRight />}>
                {expanded ? 'Hide' : 'Show'}</Button>
            }
          </Box>
        )
      }
        {!fullScreen && (<ChannelSearch />)}
      <TeamChannelsList streamUser={streamUser} fullScreen={fullScreen} />
    </div>
  </Box>
  )
};
